import { useQuery } from '@tanstack/react-query';

import type { OrganizationsSavvySearchParams } from '@/api/v4/organizations-search-savvy.api';
import { fetchOrganizationsSavvySearchResults } from '@/api/v4/organizations-search-savvy.api';
import { QueryKey } from '@/config/query-client';

export const useOrganizationsSavvySearchQuery = (
  params: OrganizationsSavvySearchParams,
) => {
  return useQuery({
    queryKey: [QueryKey.CompaniesSearchSavvy, params],
    queryFn: () => fetchOrganizationsSavvySearchResults(params),
    enabled: !!params.search,
  });
};
